import request from '@/utils/request'

// 重置密码
export function resetpass(data) {
  return request({
    url: '/api/forgot/password/reset/',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/resetpass.js